import { render, staticRenderFns } from "./ncsJobTable.vue?vue&type=template&id=a5102e18&"
import script from "./ncsJobTable.vue?vue&type=script&lang=js&"
export * from "./ncsJobTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports